import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	smartFieldsLabel: {
		id: 'issue-create.modal.create-form.actions-container.dropdown-menu.smartfields-dropdown-item.smart-fields-label',
		defaultMessage: 'Hide unused fields',
		description: 'Label for hide unused fields menu item in issue-create modal header',
	},
});
